import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Input } from '@beef/ui-kit';

import { createQuickOrder, setActiveSortButton } from 'store/ProductDetails/delivery/actions';
import { getDeliverySortActiveButton } from 'store/ProductDetails/delivery/selectors';
import ContentWrap from 'bricks/ContentWrap';
import { Grid, Col } from 'bricks/Grid';
import { getProductId } from 'store/ProductDetails/selectors';
import { getCurrentRegionId } from 'store/common/settings/selectors';
import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';

import TakeAwayDropDown from './components/TakeAwayDropdown/index';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const mapStateToPropsDropdown = (state) => ({
  sortBy: getDeliverySortActiveButton(state),
  isTablet: isScreenBelow1004(state),
});

const mapDispatchToPropsDropdown = {
  changeActiveSortButton: setActiveSortButton,
};

connect(mapStateToPropsDropdown, mapDispatchToPropsDropdown)(TakeAwayDropDown);
class TakeawayControlsLayout extends Component {
  /** only send event if query actually changed */
  constructor(props) {
    super(props);
    /* eslint-disable react/no-unused-state */
    this.state = { slug: 0 };
  }

  handleSearchBarBlur = () => {
    const { onSearchQueryBlur, searchQuery } = this.props;
    if (this.lastQuery !== searchQuery) {
      onSearchQueryBlur(searchQuery);
    }
    this.lastQuery = searchQuery;
  };

  render() {
    const {
      searchQuery,
      onSearchQueryChange,
      isMobile,
      /* isTablet, */ className,
      onSearchQueryFocus,
      isSmallTablet,
    } = this.props;
    return (
      <div className={cx(className, 'component', isMobile && 'mobile')}>
        <div className={cx('header')}>Поиск магазинов билайн</div>
        <div>
          <ContentWrap size={['xl']}>
            <Grid>
              <Col size={7} l={12}>
                <Input
                  type="search"
                  placeholder="Поиск"
                  value={searchQuery}
                  onChange={(e) => onSearchQueryChange(e.target.value)}
                  onFocus={onSearchQueryFocus}
                  onBlur={this.handleSearchBarBlur}
                  className={cx('searchField', isMobile && 'mobile')}
                />
              </Col>
              <Col size={2} l={12} />
              <Col size={3} l={12}>
                {!isSmallTablet && <TakeAwayDropDown />}
              </Col>
            </Grid>
          </ContentWrap>
        </div>
      </div>
    );
  }
}

TakeawayControlsLayout.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  noRoute: false,
};

TakeawayControlsLayout.propTypes = {
  searchQuery: PropTypes.string,
  onSearchQueryChange: PropTypes.func,
  onSearchQueryBlur: PropTypes.func,
  onSearchQueryFocus: PropTypes.func,
  isMobile: PropTypes.bool,
  isSmallTablet: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

const mapStateToProps = (state) => ({
  sortBy: getDeliverySortActiveButton(state),
  productId: getProductId(state),
  regionId: getCurrentRegionId(state),
});

const mapDispatchToProps = {
  changeActiveSortButton: setActiveSortButton,
  createOrder: createQuickOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(TakeawayControlsLayout);
